import { DeepPartial } from 'ts-essentials';
import { ISlideProps, ISlideData, DeltaOf } from '@tencent/slide-sdk-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { DataModelCommonConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/data-model-common/model-id-type-converter';

export class NotePropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<ISlideProps>,
        uiData: ISlideModel,
    ): void {
        DataModelCommonConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<ISlideModel>,
        sdkData: DeltaOf<ISlideData>,
    ): void {
        DataModelCommonConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
    }
}
